import type {
  DropdownOpeningAlignment,
  DropdownOpeningDirection,
  DropdownPosition,
} from '../models/common.models';

export function calculateDropdownPosition(
  containerBounds: DOMRect,
  dropdownAlignment: DropdownOpeningAlignment,
  dropdownDirection: DropdownOpeningDirection,
  scrollY: number,
  appSelectDropdownRef: DOMRect,
  isUsingTeleport: boolean
): DropdownPosition {
  const spacing = 4;
  let topPosition;
  let leftPosition;
  if (isUsingTeleport) {
    topPosition =
      dropdownDirection === 'open-below'
        ? `${containerBounds.bottom + scrollY + spacing}px`
        : `${
            containerBounds.top +
            scrollY -
            appSelectDropdownRef.height -
            spacing
          }px`;

    leftPosition =
      dropdownAlignment === 'align-left'
        ? `${containerBounds.left}px`
        : `${containerBounds.right - appSelectDropdownRef.width}px`;
  } else {
    topPosition =
      dropdownDirection === 'open-below'
        ? `${containerBounds.height + spacing}px`
        : `${-appSelectDropdownRef.height - spacing}px`;

    leftPosition =
      dropdownAlignment === 'align-left'
        ? `0px`
        : `${containerBounds.width - appSelectDropdownRef.width}px`;
  }

  return { topPosition, leftPosition };
}
